import React from 'react';
import classnames from 'classnames';

const styles = {
  warning: {
    base: 'p-2 bg-yellow-100 text-sm rounded-b',
    header: 'bg-yellow-300',
    paragraph: 'bg-yellow-100',
    border: 'border-l-4 border-l-amber-300 pl-4',
  },
  message: {
    base: 'p-2 bg-gray-100 text-sm rounded-b',
    header: 'bg-gray-300',
    paragraph: 'bg-gray-100',
    border: 'border-l-4 border-l-amber-300 pl-4',
  },
  warningLite: {
    base: 'p-2 bg-yellow-50 text-md rounded-b py-3 font-light shadow-md',
    header: '',
    paragraph: 'inline-block pr-16',
    border: 'border-l-4 border-l-yellow-600 pl-4',
  },
};

const InfoBox = ({ showBorder = false, title, children, type = 'warning' }) => {
  return (
    <div className="my-2">
      {title && (
        <h5
          className={classnames(
            'p-2 -mb-1 text-gray-800 text-sm font-bold rounded-t',
            styles[type].header
          )}
        >
          {title}
        </h5>
      )}

      {children && (
        <div
          className={classnames(styles[type].base, styles[type].paragraph, {
            [styles[type].border]: showBorder,
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default InfoBox;
